
/* injects from baggage-loader */

'use strict';

import SplitPdfModalController from './splitpdfmodal.controller';
import SplitPdfModalTemplate from './splitpdfmodal.html';

export default class SplitPdfModalComponent {
		constructor() {
				this.templateUrl = SplitPdfModalTemplate;
				this.controller = SplitPdfModalController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = {
					resolve: '<',
					close: '&',
					dismiss: '&'
				};
		}
}



// WEBPACK FOOTER //
// ./src/app/components/splitPdfModal/splitpdfmodal.component.js